var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkedinContactSvg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M1.37091 8.98039H4.79836V19.2941H1.37091V8.97255V8.98039ZM3.10425 4C1.92778 4 1.16699 4.76863 1.16699 5.78039C1.16699 6.76863 1.91209 7.56863 3.06503 7.56863H3.08072C4.28072 7.56863 5.02582 6.76863 5.02582 5.78039C5.00229 4.76863 4.28072 4 3.10425 4ZM13.2219 8.72941C12.5997 8.70449 11.9826 8.85072 11.4377 9.15219C10.8928 9.45367 10.4411 9.89883 10.1317 10.4392V8.97255H6.6964C6.74346 9.9451 6.6964 19.2941 6.6964 19.2941H10.1317V13.5294C10.1317 13.2157 10.1474 12.9176 10.2415 12.6902C10.4925 12.0784 11.0572 11.4353 11.9984 11.4353C13.2454 11.4353 13.7395 12.3843 13.7395 13.7725V19.2941H17.167V13.3804C17.167 10.2039 15.4807 8.72941 13.2219 8.72941Z",
    fill: "#2A3142"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinContactSvg);
export default __webpack_public_path__ + "static/media/LinkedinContactSvg.9d142628afac335d40cc10e384acce32.svg";
export { ForwardRef as ReactComponent };